import type {
  SummaryExcerpt,
  TranscriptExcerpt,
} from "../providers/commons/transcriptSearch";

/**
 * Where a meeting matched a search, and the excerpt to show for it once one has
 * loaded. No excerpt yet means the row shows "Found in transcript" or "Found in
 * summary" in its place.
 */
export type MeetingTextMatch =
  | { kind: "transcript"; excerpt?: TranscriptExcerpt }
  | { kind: "summary"; excerpt?: SummaryExcerpt };

/**
 * The one excerpt a row shows. A transcript excerpt wins, because its time
 * opens the recording at the moment the words were said. A summary excerpt
 * stands in when the meeting matched only in its summary, or when its
 * transcript matched as a whole but no single cue did, which leaves no
 * transcript excerpt to show (LCATOMICZO-76 phase 4's known gap).
 */
export const pickMeetingTextMatch = ({
  inTranscript,
  inSummary,
  transcript,
  summary,
}: {
  inTranscript: boolean;
  inSummary: boolean;
  transcript?: TranscriptExcerpt;
  summary?: SummaryExcerpt;
}): MeetingTextMatch | undefined => {
  if (inTranscript && transcript)
    return { kind: "transcript", excerpt: transcript };
  if (inSummary && summary) return { kind: "summary", excerpt: summary };
  if (inTranscript) return { kind: "transcript" };
  if (inSummary) return { kind: "summary" };
  return undefined;
};
